import styles from './Loading.module.scss'

/**
 * Application loading indicator.
 *
 * Renders a pulsing project/developer logo resolved by the parent via useProjectLogo.
 * Renders an invisible placeholder while logoSrc is null (still resolving HEAD requests)
 * to avoid a fallback-SVG → real-logo flash.
 *
 * @param {{ logoSrc: string|null }} props
 */
export function Loading({ logoSrc }) {
  if (!logoSrc) {
    return <div className={styles.loading} aria-hidden="true" />
  }

  return (
    <div className={styles.loading}>
      <img
        src={logoSrc}
        alt=""
        aria-hidden="true"
        className={styles.loadingLogo}
      />
    </div>
  )
}
